module.exports = __webpack_public_path__ + "img/iphone-x-frame.c368868.png";